import { render } from "./thankYou.vue?vue&type=template&id=1751ccfe"
import script from "./thankYou.vue?vue&type=script&lang=js"
export * from "./thankYou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__